import React, {useEffect, useState} from "react";
import {Controller, useFormContext} from "react-hook-form";
import {useGetQuery} from "../../hooks/useQueryHooks";
import {ResponseList} from "../../models/clientModels/interfaces/Response";
import {
  checkTypeNames,
  EQWorkOrder,
  getSerialNumber,
} from "../../models/serverModels/workOrder/EQWorkOrder";

import {
  initialStatisticsItem2ListParams,
  WOStatistics2,
} from "../../models/serverModels/workOrder/WOStatistics2";
import {
  initializeStatisticsCategory,
  initialStatisticsCategoryListParams,
  WOStatisticsCategory,
} from "../../models/serverModels/workOrder/WOStatisticsCategory";

import {
  Box,
  Button,
  Grid,
  MenuItem,
  Select,
  SelectChangeEvent,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextareaAutosize,
  Typography,
} from "@mui/material";
import * as statisticsCategoryApi from "../../api/statisticsApi/statisticsCategoryApi";
import * as statisticsItem2Api from "../../api/statisticsApi/statisticsItem2Api";
import * as changeRequestApi from "../../api/workOrderApi/changeRequestApi";
import MWCaption from "../../components/MWCaption";
import {FormContents} from "../../styledComponents/StyledCreateForm";

import {useRecoilValue, useSetRecoilState} from "recoil";
import {typeValue} from "../../models/clientModels/data/selectList";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {StyledDetailContainer, StyledDetailTable} from "../../styledComponents/StyledDetail";

import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import SearchIcon from "@mui/icons-material/Search";
import SpellcheckIcon from "@mui/icons-material/Spellcheck";
import {Stack, styled} from "@mui/system";
import {Link} from "react-router-dom";
import MWInputDate from "../../components/MWInputDate";
import MWInputFile from "../../components/MWInputFile";
import {useDepartmentList} from "../../hooks/useDepartmentList";
import {
  EQChangeRequest,
  getChangeNo,
  initializeChangeRequestListParams,
} from "../../models/serverModels/workOrder/EQChangeRequest";
import {
  initializeStatisticsItem,
  WOStatisticsItem,
} from "../../models/serverModels/workOrder/WOStatisticsItem";
import {changeRequestToggleState} from "../../Recoil/Atom/changeRequestState";
import ChangeRequestPopup from "./ChangeRequestPopup";
import {tipsModalState} from "../../Recoil/Atom/modalState";
export const GridCell = styled(Box)(({theme}) => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "8px",
  border: "1px solid #400",
}));

type SubTitleColorProps = {
  captionColor?: string;
};

const WorkOrderForm = ({captionColor}: SubTitleColorProps) => {
  const tokenState = useRecoilValue(tokenSelector);

  const setIsOpen = useSetRecoilState(tipsModalState);

  const setChangeRequestToggle = useSetRecoilState(changeRequestToggleState);

  const [statisticsCategory, setStatisticsCategory] = useState<WOStatisticsCategory[]>([
    initializeStatisticsCategory,
  ]);

  const [statisticsItem, setStatisticsItem] = useState<WOStatisticsItem[]>([
    initializeStatisticsItem,
  ]);
  const {departmentList} = useDepartmentList();

  const methods = useFormContext<EQWorkOrder>();

  const {setValue, getValues, control, watch} = methods;

  // note List

  const {data: changeRequestList} = useGetQuery<ResponseList<EQChangeRequest>>({
    key: ["ChangeRequestList", {...initializeChangeRequestListParams, token: tokenState}],
    api: () => changeRequestApi.getList({...initializeChangeRequestListParams, token: tokenState}),
    options: {
      refetchOnWindowFocus: false,
    },
  });

  // note statisticsCategoryList
  const {data: categoryList, isSuccess} = useGetQuery<ResponseList<WOStatisticsCategory>>({
    key: ["statisticsCategoryList", {...initialStatisticsCategoryListParams, token: tokenState}],
    api: () =>
      statisticsCategoryApi.getList({...initialStatisticsCategoryListParams, token: tokenState}),
  });

  // note statistics2List
  const {data: statistics2List} = useGetQuery<ResponseList<WOStatistics2>>({
    key: ["statistics2List", {...initialStatisticsItem2ListParams, token: tokenState}],
    api: () => statisticsItem2Api.getList({...initialStatisticsItem2ListParams, token: tokenState}),
  });

  const categoryHandler = (event: SelectChangeEvent<number>) => {
    setStatisticsItem([]);
    setValue("statisticsCategory", event.target.value as number);
    statisticsCategory.filter(
      (item) => item.uid === event?.target.value && setStatisticsItem(item.items)
    );
  };

  useEffect(() => {
    setStatisticsCategory(categoryList?.items!);
    setStatisticsItem(
      categoryList?.items?.find((item) => item.uid === getValues("statisticsCategory") && item)
        ?.items!
    );
  }, [categoryList, getValues]);

  return (
    <React.Fragment>
      <StyledDetailContainer>
        <MWCaption title={"의뢰서 작성 1"} color={captionColor} icon={<SpellcheckIcon />} />
        <FormContents container rowSpacing={4}>
          <StyledDetailTable>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell component="th" width="10%">
                    발행번호
                  </TableCell>
                  <TableCell component="td" width="23.33%">
                    {getSerialNumber(getValues())}
                    <span style={{paddingLeft: "4px", color: "#4b5279"}}>
                      (작성일자:
                      {getValues("writeDate")
                        ? `${new Date(getValues("writeDate")).getFullYear()}년 ${
                            new Date(getValues("writeDate")).getMonth() + 1
                          }월 ${new Date(getValues("writeDate")).getDate()}일`
                        : `${new Date().getFullYear()}년 ${
                            new Date().getMonth() + 1
                          }월 ${new Date().getDate()}일`}
                      )
                    </span>
                  </TableCell>
                  <TableCell component="th" width="10%">
                    작성부서
                  </TableCell>
                  <TableCell component="td" width="23.33%">
                    {getValues("department")}
                  </TableCell>
                  <TableCell component="th" width="10%">
                    작성자
                  </TableCell>
                  <TableCell component="td" width="23.33%">
                    {getValues("writerName")}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">설비분류</TableCell>
                  <TableCell component="td">
                    {typeValue.map((item) =>
                      item.value === getValues("specification.type") ? item.label : ""
                    )}
                  </TableCell>
                  <TableCell component="th">
                    <span>설비번호</span>
                    <Link to={`/WorkOrder/SelectSpecification/`} style={{marginLeft: "8px"}}>
                      변경
                    </Link>
                    <span> | </span>
                    <Link to={`/Equipment/Create`}>추가</Link>
                  </TableCell>
                  <TableCell component="td">{getValues("specification.identifyNumber")}</TableCell>
                  <TableCell component="th">설비명</TableCell>
                  <TableCell component="td">{getValues("specification.name")}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </StyledDetailTable>
        </FormContents>
      </StyledDetailContainer>
      <StyledDetailContainer>
        <MWCaption
          title={"의뢰서 작성 2"}
          color={captionColor}
          icon={<DriveFileRenameOutlineIcon />}
        />
        <FormContents container rowSpacing={4}>
          <StyledDetailTable>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell component="th" width="10%">
                    요청일자
                  </TableCell>
                  <TableCell component="td" width="23.33%">
                    <MWInputDate name="requestDate" />
                  </TableCell>
                  <TableCell component="th" width="10%">
                    점검구분
                  </TableCell>
                  <TableCell component="td" colSpan={2} width="23.33%">
                    <Controller
                      name="checkType"
                      control={control}
                      render={({field}) => (
                        <Grid container alignItems="center" justifyContent="flex-start">
                          <Grid item xs={12}>
                            <Select
                              {...field}
                              id="checkType"
                              size="small"
                              defaultValue={field.value}
                              style={{width: "100%"}}
                            >
                              <MenuItem disabled value={field.value} style={{display: "none"}}>
                                선택하세요
                              </MenuItem>
                              {checkTypeNames! !== undefined &&
                                checkTypeNames!.map((item, index) => (
                                  <MenuItem key={index} value={index}>
                                    {item}
                                  </MenuItem>
                                ))}
                            </Select>
                          </Grid>
                        </Grid>
                      )}
                    />
                  </TableCell>
                  <TableCell component="th" width="10%">
                    부서명
                  </TableCell>
                  <TableCell component="td" width="23.33%">
                    <Controller
                      name="processDepartmentUID"
                      control={control}
                      render={({field}) => (
                        <Grid container alignItems="center" justifyContent="flex-start">
                          <Grid item xs={12}>
                            <Select
                              {...field}
                              id="processDepartmentUID"
                              size="small"
                              defaultValue={field.value}
                              style={{width: "100%"}}
                            >
                              <MenuItem disabled value={field.value} style={{display: "none"}}>
                                선택하세요
                              </MenuItem>
                              {departmentList?.items! !== undefined &&
                                departmentList?.items!.map((item, index) => (
                                  <MenuItem key={item.uid} value={item.uid}>
                                    {item.name}
                                  </MenuItem>
                                ))}
                            </Select>
                          </Grid>
                        </Grid>
                      )}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">통계번호(유형)</TableCell>
                  <TableCell component="td">
                    <Controller
                      name="statisticsCategory"
                      control={control}
                      render={({field}) => (
                        <Grid container alignItems="center" justifyContent="flex-start">
                          <Grid item xs={12}>
                            <Select
                              {...field}
                              id="statisticsCategory"
                              size="small"
                              defaultValue={field.value}
                              style={{width: "100%"}}
                              onChange={categoryHandler}
                            >
                              <MenuItem disabled value={field.value} style={{display: "none"}}>
                                선택하세요
                              </MenuItem>
                              {statisticsCategory !== undefined &&
                                statisticsCategory.map((item, index) => (
                                  <MenuItem key={item.uid} value={item.uid}>
                                    {item.categoryName}
                                  </MenuItem>
                                ))}
                            </Select>
                          </Grid>
                        </Grid>
                      )}
                    />
                  </TableCell>
                  <TableCell component="th">통계번호(장치)</TableCell>
                  <TableCell component="td" colSpan={2}>
                    <Controller
                      name="statisticsItem"
                      control={control}
                      render={({field}) => (
                        <Grid container alignItems="center" justifyContent="flex-start">
                          <Grid item xs={12}>
                            <Select
                              {...field}
                              id="statisticsItem"
                              size="small"
                              defaultValue={field.value}
                              onChange={(e) => field.onChange(e.target.value)}
                              style={{width: "100%"}}
                            >
                              <MenuItem disabled value={field.value} style={{display: "none"}}>
                                선택하세요
                              </MenuItem>
                              {statisticsItem?.map((item, index) => (
                                <MenuItem key={item.uid} value={item.uid}>
                                  {item.itemName}
                                </MenuItem>
                              ))}
                            </Select>
                          </Grid>
                        </Grid>
                      )}
                    />
                  </TableCell>
                  <TableCell component="th">통계번호(상태)</TableCell>
                  <TableCell component="td">
                    <Controller
                      name="statistics2"
                      control={control}
                      render={({field}) => (
                        <Grid container alignItems="center" justifyContent="flex-start">
                          <Grid item xs={12}>
                            <Select
                              {...field}
                              id="statistics2"
                              size="small"
                              defaultValue={field.value}
                              style={{width: "100%"}}
                            >
                              <MenuItem disabled value={field.value} style={{display: "none"}}>
                                선택하세요
                              </MenuItem>
                              {statistics2List?.items !== undefined &&
                                statistics2List?.items.map((item, index) => (
                                  <MenuItem key={item.uid} value={item.uid}>
                                    {item.itemName}
                                  </MenuItem>
                                ))}
                            </Select>
                          </Grid>
                        </Grid>
                      )}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">설비등급</TableCell>
                  <TableCell component="td">{getValues("specification.eqLevel")}</TableCell>

                  <TableCell component="th">
                    <span style={{marginRight: "4px"}}>변경여부</span>
                    <Button
                      onClick={() => {
                        setIsOpen(true);
                      }}
                    >
                      판단기준
                    </Button>
                    {/* <a href="/#" style={{fontSize: "12px"}}>
                      판단기준
                    </a> */}
                  </TableCell>
                  <TableCell component="td" colSpan={2}>
                    <Controller
                      name="isChangable"
                      control={control}
                      render={({field}) => (
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography>비대상</Typography>
                          <Switch checked={field.value} onChange={field.onChange} />
                          <Typography>대상</Typography>
                        </Stack>
                      )}
                    />
                  </TableCell>
                  <TableCell component="th">변경 NO</TableCell>
                  <TableCell component="td">
                    <Button
                      variant="contained"
                      size="small"
                      onClick={() => {
                        setChangeRequestToggle(true);
                      }}
                      startIcon={<SearchIcon />}
                    >
                      조회
                    </Button>
                    <span style={{paddingLeft: "8px"}}>
                      {getChangeNo(watch())}
                      {/* {changeRequestList?.items.map(
                        (item) => item.uid === getValues("changeRequestUID") && item.serialString
                      )} */}
                    </span>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">요청(고장)내용</TableCell>
                  <TableCell component="td" colSpan={6}>
                    <Controller
                      name="requestContent"
                      control={control}
                      render={({field: {onChange, value}}) => (
                        <TextareaAutosize
                          defaultValue={value}
                          aria-label="minimum height"
                          minRows={3}
                          onChange={onChange}
                          style={{width: "100%", padding: "8px"}}
                        />
                      )}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" width="10%">
                    개선 전 사진
                  </TableCell>
                  <TableCell component="td" width="40%" colSpan={2}>
                    <MWInputFile file="preFileBase64" fileName="preFile" buttonLabel="이미지선택" />
                  </TableCell>
                  <TableCell component="th" width="10%">
                    관련자료
                  </TableCell>
                  <TableCell component="td" width="40%" colSpan={3}>
                    <MWInputFile file="etcFileBase64" fileName="etcFile" />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </StyledDetailTable>
        </FormContents>
      </StyledDetailContainer>
      <ChangeRequestPopup setValue={setValue} name="changeRequest" />
    </React.Fragment>
  );
};

export default WorkOrderForm;
